import { useEffect, useState } from 'react';
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
} from 'react-bootstrap';
import Feedback from 'react-bootstrap/esm/Feedback';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import axiosApi from '../../axios/axios-api';
import { LogoPetroprix } from '../ui/LogoPetroprix';
import { useDispatch, useSelector } from 'react-redux';
import { startLogout } from '../../store/auth';
import { ValidateToken } from '../../helpers/validateToken';
const URL_EDITAR_VEHICULO_FLOTA = 'flotas/vehiculos/';
const URL_EDITAR_PIN_VEHICULO_FLOTA = 'flotas/vehiculos/pin/';

export function ModalEditarVehiculo(props) {
  const {
    id_vehiculo_flota,
    id_cuenta_facturacion,
    credito_definido,
    credito_usado,
    matricula,
    factura,
    descripcion,
    max_operacion,
    max_op_red,
    max_op_30,
    tipo_vehiculo,
  } = props;

  const [pin, setPin] = useState(0);
  const [limiteCredito, setLimiteCredito] = useState();
  const [creditoDefinido, setCreditoDefinido] = useState();
  const [validated, setValidated] = useState(false);
  const [loadedInfo, setLoadedInfo] = useState(false);
  const [savingData, setSavingData] = useState(false);

  const { token, idClienteFlota } = useSelector((state) => state.auth);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    matricula: matricula,
    tipoVehiculo: tipo_vehiculo,
    factura: factura,
    limiteCredito: limiteCredito,
    cantidadLimite: creditoDefinido,
    pinSelect: '0',
    pinTxt: '',
    pinTxtRepeat: '',
    impMaxRepost: max_operacion,
    impMaxDiaPetroprix: max_op_red,
    numRepostDia30Min: max_op_30,
    descripcion: descripcion,
  });

  useEffect(() => {
    setFormData({
      matricula: matricula,
      tipoVehiculo: tipo_vehiculo,
      factura: factura,
      limiteCredito: limiteCredito,
      cantidadLimite: creditoDefinido,
      pinSelect: '0',
      pinTxt: '',
      pinTxtRepeat: '',
      impMaxRepost: max_operacion,
      impMaxDiaPetroprix: max_op_red,
      numRepostDia30Min: max_op_30,
      descripcion: descripcion,
    });
  }, [props]);

  const [formErrors, setFormErrors] = useState({
    matricula: false,
    tipoVehiculo: false,
    factura: false,
    pinTxt: false,
    pinTxtRepeat: false,
    limiteCredito: false,
    cantidadLimite: false,
    impMaxRepost: false,
    impMaxDiaPetroprix: false,
    numRepostDia30Min: false,
  });

  useEffect(() => {
    setValidated(false);
    if (
      credito_definido === 'Sin limite' ||
      credito_definido === -1 ||
      credito_definido === '-1'
    ) {
      setLimiteCredito('-1');
      setCreditoDefinido(undefined);
      setFormData((prevData) => ({
        ...prevData,
        limiteCredito: '-1',
        cantidadLimite: undefined,
      }));
    } else {
      setLimiteCredito('1');

      // Guard against null/undefined and ensure we operate on a string
      const hasPositiveValue =
        credito_definido !== null &&
        credito_definido !== undefined &&
        credito_definido !== '' &&
        Number(credito_definido) > 0;

      if (hasPositiveValue) {
        const creditoStr = String(credito_definido);
        setCreditoDefinido(creditoStr.replace('.', '').split(',')[0]);
        setFormData((prevData) => ({
          ...prevData,
          limiteCredito: '1',
          cantidadLimite: creditoStr.replace('.', '').split(',')[0],
        }));
      } else {
        setCreditoDefinido(credito_definido);
        setFormData((prevData) => ({
          ...prevData,
          limiteCredito: '1',
          cantidadLimite: credito_definido,
        }));
      }
    }

    setLoadedInfo(true);
  }, [credito_definido]);

  const editVehicle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValidated(false);
    setSavingData(true);

    let limite_mensual_value = '-1';

    let validateForm = {
      tipoVehiculo: false,
      factura: false,
      pinTxt: false,
      pinTxtRepeat: false,
      limiteCredito: false,
      cantidadLimite: false,
      impMaxRepost: false,
      impMaxDiaPetroprix: false,
      numRepostDia30Min: false,
    };

    if (formData.factura === '') {
      validateForm.factura = true;
    } else {
      validateForm.factura = false;
    }

    if (formData.pinSelect === '1') {
      if (
        formData.pinTxt === '' ||
        formData.pinTxt.length !== 4 ||
        isNaN(formData.pinTxt)
      ) {
        validateForm.pinTxt = true;
        validateForm.pinTxtRepeat = true;
      } else if (
        formData.pinTxtRepeat === '' ||
        formData.pinTxtRepeat.length !== 4 ||
        isNaN(formData.pinTxtRepeat)
      ) {
        validateForm.pinTxtRepeat = true;
        validateForm.pinTxt = false;
      } else if (formData.pinTxt !== formData.pinTxtRepeat) {
        validateForm.pinTxtRepeat = true;
        validateForm.pinTxt = true;
      } else {
        validateForm.pinTxtRepeat = false;
        validateForm.pinTxt = false;
      }
    } else {
      validateForm.pinTxtRepeat = false;
      validateForm.pinTxt = false;
    }

    if (formData.limiteCredito === '1') {
      if (formData.cantidadLimite === '' || formData.cantidadLimite < 0) {
        validateForm.limiteCredito = true;
        validateForm.cantidadLimite = true;
      } else {
        validateForm.limiteCredito = false;
        validateForm.cantidadLimite = false;
      }
    } else {
      validateForm.limiteCredito = false;
      validateForm.cantidadLimite = false;
    }

    if (formData.impMaxRepost === '') {
      validateForm.impMaxRepost = true;
    } else {
      validateForm.impMaxRepost = false;
    }

    if (formData.impMaxDiaPetroprix === '') {
      validateForm.impMaxDiaPetroprix = true;
    } else {
      validateForm.impMaxDiaPetroprix = false;
    }

    if (formData.numRepostDia30Min === '') {
      validateForm.numRepostDia30Min = true;
    } else {
      validateForm.numRepostDia30Min = false;
    }

    // Para tipo de vehículo - verificar que no sea la opción disabled
    if (formData.tipoVehiculo === '' || formData.tipoVehiculo === undefined) {
      validateForm.tipoVehiculo = true;
    } else {
      validateForm.tipoVehiculo = false;
    }

    // Para factura - verificar que tenga un valor válido
    if (formData.factura === '' || formData.factura === undefined) {
      validateForm.factura = true;
    } else {
      validateForm.factura = false;
    }

    if (
      validateForm.factura ||
      validateForm.pinTxt ||
      validateForm.pinTxtRepeat ||
      validateForm.limiteCredito ||
      validateForm.impMaxRepost ||
      validateForm.impMaxDiaPetroprix ||
      validateForm.numRepostDia30Min ||
      validateForm.tipoVehiculo
    ) {
      setFormErrors({
        ...formErrors,
        tipoVehiculo: validateForm.tipoVehiculo,
        factura: validateForm.factura,
        pinTxt: validateForm.pinTxt,
        pinTxtRepeat: validateForm.pinTxtRepeat,
        limiteCredito: validateForm.limiteCredito,
        cantidadLimite: validateForm.cantidadLimite,
        impMaxRepost: validateForm.impMaxRepost,
        impMaxDiaPetroprix: validateForm.impMaxDiaPetroprix,
        numRepostDia30Min: validateForm.numRepostDia30Min,
      });
      setValidated(true);
      setSavingData(false);
      return;
    } else {
      // Limpiar errores si todo está correcto
      setFormErrors({
        matricula: '',
        tipoVehiculo: '',
        factura: '',
        pinTxt: '',
        pinTxtRepeat: '',
        limiteCredito: '',
        cantidadLimite: '',
        impMaxRepost: '',
        impMaxDiaPetroprix: '',
        numRepostDia30Min: '',
      });
      setValidated(true);

      let data = {
        id_customer_fleet: idClienteFlota,
        plate_number: formData.matricula,
        id_billing_account: id_cuenta_facturacion,
        vehicle_type: formData.tipoVehiculo,
        assigned_credit:
          formData.limiteCredito === '-1'
            ? parseFloat(-1)
            : parseFloat(formData.cantidadLimite),
        max_operation: formData.impMaxRepost,
        max_op_red: formData.impMaxDiaPetroprix,
        max_op_30: formData.numRepostDia30Min,
        description: formData.descripcion,
        invoice: formData.factura,
      };

      try {
        if (process.env.REACT_APP_URL_API && ValidateToken()) {
          const response = await axiosApi.put(
            URL_EDITAR_VEHICULO_FLOTA + id_vehiculo_flota,
            data,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token,
              },
            }
          );
          if (response?.data?.code === 200) {
            if (formData.pinSelect === '1') {
              let dataPin = {
                pin: formData.pinTxt,
                confirm_pin: formData.pinTxtRepeat,
              };
              const responsePIN = await axiosApi.put(
                URL_EDITAR_PIN_VEHICULO_FLOTA + id_vehiculo_flota,
                dataPin,
                {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + token,
                  },
                }
              );
              if (responsePIN?.data?.code === 200) {
                props.onHide(true);
                setSavingData(false);
                toast(t('flotas.modal.editar.result.ok'), {
                  icon: <LogoPetroprix />,
                });
              } else {
                setSavingData(false);
                toast(t('flotas.modal.editar.result.ko.pin'), {
                  icon: <LogoPetroprix />,
                });
              }
            } else {
              props.onHide(true);
              setSavingData(false);
              toast(t('flotas.modal.editar.result.ok'), {
                icon: <LogoPetroprix />,
              });
            }
          } else {
            setSavingData(false);
            toast(t('flotas.modal.editar.result.ko'), {
              icon: <LogoPetroprix />,
            });
          }
        } else {
          setSavingData(false);
          dispatch(startLogout('expired'));
        }
      } catch (error) {
        setSavingData(false);
        console.error(error);
      }
    }
  };

  return (
    <Modal
      {...props}
      size='xl'
      aria-labelledby='contained-modal-title-vcenter'
      centered
      dialogClassName='modal-80w'
    >
      <Modal.Header>
        <Modal.Title>{t('flotas.modal.editar.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='show-grid'>
        <Container>
          <Form
            noValidate
            validated={validated}
            autoComplete='off'
            onSubmit={(e) => editVehicle(e)}
          >
            {/* Información no editable del vehiculo */}
            <Row>
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.matricula')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    placeholder={t('flotas.modal.editar.form.matricula')}
                    disabled
                    value={matricula}
                  />
                </FloatingLabel>
              </Col>
              <Col sm={12} lg={3}>
                <FloatingLabel
                  controlId='floatingSelect'
                  label={t('flotas.modal.editar.form.tipo-vehiculo')}
                  className='mb-3'
                >
                  <Form.Select
                    aria-label="{t('flotas.modal.editar.form.tipo-vehiculo')}"
                    placeholder={t('flotas.modal.editar.form.tipo-vehiculo')}
                    id='flotas-modal-editar-form-tipo-vehiculo'
                    defaultValue={formData.tipoVehiculo}
                    isInvalid={validated && formErrors.tipoVehiculo}
                    isValid={validated && !formErrors.tipoVehiculo}
                    required
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        tipoVehiculo: e.target.value,
                      });
                    }}
                  >
                    <option value='' disabled>
                      {t('flotas.modal.editar.form.tipo-vehiculo.select')}
                    </option>
                    <option value='0'>
                      {t('flotas.modal.editar.form.tipo-vehiculo.turismo')}
                    </option>
                    <option value='1'>
                      {t('flotas.modal.editar.form.tipo-vehiculo.moto')}
                    </option>
                    <option value='2'>
                      {t('flotas.modal.editar.form.tipo-vehiculo.camion')}
                    </option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.credito-usado')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    placeholder={t('flotas.modal.editar.form.credito-usado')}
                    disabled
                    value={`${credito_usado} zł`}
                  />
                </FloatingLabel>
              </Col>
              {/* Limite crédito */}
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.limite-credito')}
                  className='mb-3'
                >
                  <Form.Select
                    aria-label={t('flotas.modal.editar.form.limite-credito')}
                    placeholder={t('flotas.modal.editar.form.limite-credito')}
                    key={loadedInfo ? limiteCredito : ''}
                    defaultValue={formData.limiteCredito}
                    id='flotas-modal-editar-form-limite-credito'
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        limiteCredito: e.target.value,
                      });
                      setLimiteCredito(e.target.value);
                    }}
                  >
                    <option value='' disabled>
                      {t(
                        'flotas.registro-vehiculo.step-1.form.limite-credito.select'
                      )}
                    </option>
                    <option value='-1'>
                      {t('flotas.modal.editar.form.limite-credito.sin-limite')}
                    </option>
                    <option value='1'>
                      {t('flotas.modal.editar.form.limite-credito.definir')}
                    </option>
                  </Form.Select>
                  <Feedback type='invalid'>
                    {t(
                      'flotas.modal.editar.form.validation.limite-credito.invalid'
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>
            </Row>

            {/* Etiqueta, Factura, PIN, Limite credito */}
            <Row>
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.descripcion')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    id='flotas-modal-editar-form-descripcion'
                    placeholder={t('flotas.modal.editar.form.descripcion')}
                    value={formData.descripcion || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, descripcion: e.target.value })
                    }
                  />
                </FloatingLabel>
              </Col>
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.factura')}
                  className='mb-3'
                >
                  <Form.Select
                    aria-label={t('flotas.modal.editar.form.factura.select')}
                    placeholder={t('flotas.modal.editar.form.factura.select')}
                    defaultValue={formData.factura}
                    id='flotas-modal-editar-form-factura'
                    isInvalid={validated && formErrors.factura}
                    isValid={validated && !formErrors.factura}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, factura: e.target.value })
                    }
                  >
                    <option value='1'>
                      {t('flotas.modal.editar.form.factura.si')}
                    </option>
                    <option value='0'>
                      {t('flotas.modal.editar.form.factura.no')}
                    </option>
                  </Form.Select>
                  <Feedback type='invalid'>
                    {t('flotas.modal.editar.form.validation.factura.invalid')}
                  </Feedback>
                </FloatingLabel>
              </Col>
              {/* PIN */}
              <Col sm={12} lg={3}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.pin')}
                  className='mb-3'
                >
                  <Form.Select
                    aria-label={t('flotas.modal.editar.form.pin')}
                    placeholder={t('flotas.modal.editar.form.pin')}
                    defaultValue={formData.pinSelect}
                    id='flotas-modal-editar-form-pin-select'
                    isInvalid={validated && formErrors.pinSelect}
                    isValid={validated && !formErrors.pinSelect}
                    onChange={(e) => {
                      setFormData({ ...formData, pinSelect: e.target.value });
                      setPin(e.target.value);
                    }}
                  >
                    <option value='' disabled>
                      {t('flotas.modal.editar.form.pin.select')}
                    </option>
                    <option value='0'>
                      {t('flotas.modal.editar.form.pin.no')}
                    </option>
                    <option value='1'>
                      {t('flotas.modal.editar.form.pin.si')}
                    </option>
                  </Form.Select>
                </FloatingLabel>
                {pin === '1' && (
                  <>
                    <FloatingLabel
                      label={t('flotas.modal.editar.form.pin-input')}
                      className='mb-3'
                    >
                      <Form.Control
                        type='password'
                        id='flotas-modal-editar-form-pin'
                        placeholder={t('flotas.modal.editar.form.pin-input')}
                        maxLength='4'
                        pattern='[0-9]{4}'
                        required
                        autoComplete='new-password'
                        value={formData.pinTxt || ''}
                        onChange={(e) =>
                          setFormData({ ...formData, pinTxt: e.target.value })
                        }
                        isInvalid={validated && formErrors.pinTxt}
                        isValid={validated && !formErrors.pinTxt}
                      />
                      <Feedback type='invalid'>
                        {t('flotas.modal.editar.form.validation.pin.invalid')}
                      </Feedback>
                    </FloatingLabel>

                    <FloatingLabel
                      label={t('flotas.modal.editar.form.pin-repeat')}
                      className='mb-3'
                    >
                      <Form.Control
                        type='password'
                        id='flotas-modal-editar-form-pin-repeat'
                        placeholder={t('flotas.modal.editar.form.pin-repeat')}
                        maxLength='4'
                        pattern='[0-9]{4}'
                        required
                        autoComplete='new-password'
                        value={formData.pinTxtRepeat || ''}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            pinTxtRepeat: e.target.value,
                          })
                        }
                        isInvalid={validated && formErrors.pinTxtRepeat}
                        isValid={validated && !formErrors.pinTxtRepeat}
                      />
                      <Feedback type='invalid'>
                        {t(
                          'flotas.modal.editar.form.validation.pin-confirm.invalid'
                        )}
                      </Feedback>
                    </FloatingLabel>
                  </>
                )}
              </Col>
              {limiteCredito === '1' && (
                <Col sm={12} lg={3}>
                  <FloatingLabel
                    label={t('flotas.modal.editar.form.limite.limite-mensual')}
                    className='mb-3'
                  >
                    <Form.Control
                      type='number'
                      id='flotas-modal-editar-form-limite-mensual'
                      placeholder={t(
                        'flotas.modal.editar.form.limite.limite-mensual'
                      )}
                      min='1'
                      value={formData.cantidadLimite || ''}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          cantidadLimite: e.target.value,
                        })
                      }
                      isInvalid={validated && formErrors.cantidadLimite}
                      isValid={validated && !formErrors.cantidadLimite}
                    />
                    <Feedback type='invalid'>
                      {t(
                        'flotas.modal.editar.form.validation.limite-mensual.invalid'
                      )}
                    </Feedback>
                  </FloatingLabel>
                </Col>
              )}
            </Row>

            {/* Importes maximos y nº repostajes diarios */}
            <Row className='mt-4'>
              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.imp-max-repost')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    id='flotas-modal-editar-form-impMaxRepost'
                    placeholder={t('flotas.modal.editar.form.imp-max-repost')}
                    value={formData.impMaxRepost || ''}
                    onChange={(e) =>
                      setFormData({ ...formData, impMaxRepost: e.target.value })
                    }
                    isInvalid={validated && formErrors.impMaxRepost}
                    isValid={validated && !formErrors.impMaxRepost}
                  />
                  <Feedback type='invalid'>
                    {t(
                      'flotas.modal.editar.form.validation.imp-max-repost.invalid'
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.imp-max-repost-petroprix')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    id='flotas-modal-editar-form-impMaxRepostPetroprix'
                    placeholder={t(
                      'flotas.modal.editar.form.imp-max-repost-petroprix'
                    )}
                    value={formData.impMaxDiaPetroprix || ''}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        impMaxDiaPetroprix: e.target.value,
                      })
                    }
                    isInvalid={validated && formErrors.impMaxDiaPetroprix}
                    isValid={validated && !formErrors.impMaxDiaPetroprix}
                  />
                  <Feedback type='invalid'>
                    {t(
                      'flotas.modal.editar.form.validation.imp-max-repost-petroprix.invalid'
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t('flotas.modal.editar.form.num-repost-dia-30min')}
                  className='mb-3'
                >
                  <Form.Control
                    type='text'
                    id='flotas-modal-editar-form-numRepostDia30Min'
                    placeholder={t(
                      'flotas.modal.editar.form.num-repost-dia-30min'
                    )}
                    value={formData.numRepostDia30Min || ''}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        numRepostDia30Min: e.target.value,
                      });
                    }}
                    isInvalid={validated && formErrors.numRepostDia30Min}
                    isValid={validated && !formErrors.numRepostDia30Min}
                  />
                  <Feedback type='invalid'>
                    {t(
                      'flotas.modal.editar.form.validation.num-repost-dia-30min.invalid'
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <div className='d-grid gap-2 mt-2 col-md-5 mx-auto'>
                <Button
                  variant='outline-primary'
                  size='lg'
                  onClick={() => {
                    props.onHide(false);
                  }}
                >
                  {t('flotas.modal.editar.form.btn-cancel')}
                </Button>
                <Button
                  variant='primary'
                  size='lg'
                  type='submit'
                  onClick={(e) => editVehicle(e)}
                >
                  {t('flotas.modal.editar.form.btn-guardar')}
                </Button>
              </div>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
